import { TextBody, TextSmall } from '@/design-system/components/typography';
import { keyGenerator } from '@/utils/keyGenerator';
import { ScrollView, styled, SxProp, View } from 'dripsy';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { ChainsData } from './useChainSelector';

const PressableView = styled(Pressable)();

interface ChainSelectorDropdownMenuProps {
  hasFocus: boolean;
  displayChainData: ChainsData;
  changeFocus: (value: boolean) => void;
  selectChainId: (id: string) => void;
  onValueChange: (value: string) => void;
}

export const ChainSelectorDropdownMenu: React.FC<ChainSelectorDropdownMenuProps> = ({
  hasFocus,
  displayChainData,
  changeFocus,
  selectChainId,
  onValueChange
}) => {
  if (!hasFocus) return null;

  const { t } = useTranslation('earn');

  return (
    <View sx={styles.dropdownMenu}>
      <ScrollView>
        {displayChainData.length === 0 ? (
          <View sx={{ alignItems: 'center', paddingX: '$3' }}>
            <TextBody>{t('earn-invest::glossary.search-no-result')}</TextBody>
          </View>
        ) : null}
        {displayChainData.length > 0
          ? displayChainData.map((item) => (
              <PressableView
                key={keyGenerator('account-selector')}
                onPress={() => {
                  selectChainId(item?.chain || '');
                  changeFocus(false);
                  onValueChange(item?.chain || '');
                }}>
                {({ hovered }) => (
                  <View sx={{ ...styles.dropdownItem, backgroundColor: hovered ? '$backgroundDropdownActive' : '$backgroundPopup' }}>
                    <View sx={{ flex: 1 }}>
                      <TextBody label>{item?.chain}</TextBody>
                      <TextSmall secondary>{item?.chainName}</TextSmall>
                    </View>
                  </View>
                )}
              </PressableView>
            ))
          : null}
      </ScrollView>
    </View>
  );
};

enum StyleName {
  dropdownMenu = 'dropdownMenu',
  dropdownItem = 'dropdownItem'
}

const styles: Record<StyleName, SxProp> = {
  dropdownMenu: {
    position: 'absolute',
    top: '$15',
    left: 0,
    width: '100%',
    maxHeight: 250,
    paddingY: '$2',
    backgroundColor: '$backgroundPopup',
    borderRadius: 5,
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 5,
    zIndex: 10
  },
  dropdownItem: {
    paddingX: '$4',
    paddingY: '$3',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '$3'
  }
};
